import { Link } from 'react-router-dom';
import { Post } from '../../../../lib/supabase';
import { formatDate } from '../../../../lib/utils';
import { categories } from '../../../../data/categories';

interface PostRelatedProps {
  currentPost: Post;
  allPosts: Post[];
}

export function PostRelated({ currentPost, allPosts }: PostRelatedProps) {
  const related = allPosts
    .filter(
      (p) =>
        p.id !== currentPost.id &&
        (p.category_slug === currentPost.category_slug ||
          p.tags.some((t) => currentPost.tags.includes(t)))
    )
    .slice(0, 3);

  const mockRelated = [
    {
      slug: 'cursor-composer-tips-2026',
      title: 'Cursor Composerで長い実装を分割する方法——コンテキスト切れを防ぐ3つの工夫',
      category_slug: 'ai-creation',
      published_at: '2026-04-01',
      excerpt: '長い実装をAIに任せると途中でコンテキストが切れる。その対策として試した分割戦略を整理した。',
    },
    {
      slug: 'spec-driven-development-intro',
      title: '仕様書ファーストで開発する——AIに「何を作るか」を先に伝える設計',
      category_slug: 'build-log',
      published_at: '2026-03-25',
      excerpt: 'コードを書く前に仕様書を作ると、AIとのやり取りが劇的に変わる。その具体的な手順と効果。',
    },
    {
      slug: 'vibe-coding-what-is',
      title: 'バイブコーディングとは何か——AIと一緒に作る感覚を言語化してみた',
      category_slug: 'ai-creation',
      published_at: '2026-03-20',
      excerpt: 'コードを書くというより、AIと会話しながら形にしていく感覚。その実態と、うまくいくときの条件を整理した。',
    },
  ];

  const displayPosts = related.length > 0 ? related : mockRelated;

  return (
    <section className="mt-14 sm:mt-16 pt-10 border-t border-[#EDE7DF]">
      <div className="mb-6">
        <p
          className="text-xs font-semibold tracking-widest uppercase text-[#5B7B6F] mb-1"
          style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
        >
          Related
        </p>
        <h2
          className="text-lg font-bold text-[#2C2416]"
          style={{ fontFamily: "'Noto Serif JP', serif" }}
        >
          関連記事
        </h2>
      </div>

      <div className="space-y-3">
        {displayPosts.map((p) => {
          const cat = categories.find((c) => c.slug === p.category_slug);
          return (
            <Link
              key={p.slug}
              to={`/articles/${p.slug}`}
              className="flex items-start gap-4 p-4 bg-[#F8F3EC] border border-[#E8E0D5] rounded-lg hover:border-[#C8BFB5] hover:bg-[#F0EBE3] transition-all cursor-pointer group"
            >
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5">
                  {cat && (
                    <span
                      className="text-xs text-[#5B7B6F] font-medium"
                      style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                    >
                      {cat.name}
                    </span>
                  )}
                  <span className="text-[#D4C9BE] text-xs">·</span>
                  <span
                    className="text-xs text-[#9A8E84]"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {formatDate(p.published_at)}
                  </span>
                </div>
                <h3
                  className="text-sm font-semibold text-[#2C2416] leading-snug group-hover:text-[#5B7B6F] transition-colors"
                  style={{ fontFamily: "'Noto Serif JP', serif" }}
                >
                  {p.title}
                </h3>
                {p.excerpt && (
                  <p
                    className="text-xs text-[#7A6E62] mt-1 line-clamp-1 leading-relaxed"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {p.excerpt}
                  </p>
                )}
              </div>
              <i className="ri-arrow-right-line text-[#C8BFB5] group-hover:text-[#5B7B6F] transition-colors flex-shrink-0 mt-1"></i>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
